import "core-js/modules/es.object.assign.js";
/**
 * @author Andrea Moraglia
 */
export var PORTAL;
(function (PORTAL) {
  PORTAL[PORTAL["WIKICASA"] = 0] = "WIKICASA";
  PORTAL[PORTAL["COMMERCIALI"] = 1] = "COMMERCIALI";
  PORTAL[PORTAL["CASACLICK"] = 2] = "CASACLICK";
  PORTAL[PORTAL["BLINKS"] = 3] = "BLINKS";
  PORTAL[PORTAL["WIKISERVIZI"] = 4] = "WIKISERVIZI";
  PORTAL[PORTAL["APP"] = 5] = "APP";
})(PORTAL || (PORTAL = {}));
export var searchBeanMap = {
  priceFrom: "PrezzoMinimo",
  priceTo: "PrezzoMassimo",
  sqMfrom: "SuperficieMinima",
  sqMto: "SuperficieMassima",
  roomsFrom: "NumeroMinimoLocali",
  roomsTo: "NumeroMassimoLocali",
  bathroomsFrom: "NumeroMinimoBagni",
  bathroomsTo: "NumeroMassimoBagni",
  conditionType: "StatoImmobile",
  energyClassFilter: "ClasseEnergetica",
  floor: "Piano",
  excludeAuctions: "EscludiAste",
  shortRentOnly: "SoloAffittiBrevi",
  excludeBareOwnership: "EscludiNudaProprieta",
  onlyBareOwnership: "SoloNudaProprieta",
  onlyPublicUser: "DaPrivato",
  balcony: "Balcone",
  terrace: "Terrazzo",
  balconyTerrace: "BalconeTerrazzo",
  boxCarSpot: "BoxPostoAuto",
  carSpot: "PostoAuto",
  box: "Box",
  lift: "Ascensore",
  privateGarden: "GiardinoPrivato",
  publicGarden: "GiardinoPubblico",
  cellar: "Cantina",
  airConditioning: "AriaCondizionata",
  furnished: "Arredato",
  publicTransport: "Trasporti",
  school: "Istruzione",
  market: "Supermercati",
  hospital: "Ospedali",
  pharmacy: "Farmacie",
  charging: "Ricarica",
  post: "UfficioPostale",
  bank: "Banche",
  swimmingPoolPrivate: "PiscinaPrivata",
  swimmingPoolPublic: "PiscinaCondominiale",
  luxury: "Lusso",
  discounted: "Sconto",
  auctionMinimumOfferFrom: "OffertaMinimaAstaDa",
  auctionMinimumOfferTo: "OffertaMinimaAstaA",
  auctionMinimumBid: "RialzoMinimoAsta",
  auctionCourtTypeID: "TribunaleAsta",
  auctionSaleModeID: "ModalitaVenditaAsta",
  auctionProcedureNumber: "NumeroProceduraAsta",
  auctionProcedureTypologyID: "TipologiaProceduraAsta",
  auctionReferenceYear: "AnnoRiferimentoAsta",
  auctionPublicationDateFrom: "DataPubblicazioneAstaDa",
  auctionPublicationDateTo: "DataPubblicazioneAstaA",
  auctionDateFrom: "DataAstaDa",
  auctionDateTo: "DataAstaA",
  /* Don't consider this prop in the filters counter */
  filterOrderId: "Ordinamento"
};
//SimoR: Added for filtering inside agency details wikicasa, in another const because it breaks the buildParams of the real estate listing
export var searchBeanMapAgencyFilter = {
  sale: "Vendita",
  rent: "Affitto",
  auctionType: "Asta",
  bareOwnershipType: "NudaProprieta",
  listingTypologyIdList: "listingTypologyID",
  filterOrderId: "Ordinamento"
};
export var defaultSearchBeanValues = {
  contractType: window._contractDefault,
  excludeAuctions: false,
  excludeBareOwnership: false,
  listingTypologyId: 0,
  listingTypologyIdList: [0],
  listingTypologyURL: window._listingTypologyURLDefault,
  macroTypologyId: window._macroTypologyDefault,
  onlyBareOwnership: false,
  onlyVisible: true,
  rent: false,
  sale: true,
  shortRentOnly: false,
  subscriptionTypes: window._subscriptionTypesDefault,
  typologyIdList: window._typologyIdListDefault
};
export function getDefaultSearchBean() {
  return Object.assign({}, defaultSearchBeanValues);
}
export var getDefaultAuctionFiltersSearchBean = () => {
  return Object.assign(Object.assign({}, getDefaultSearchBean()), {
    sale: false,
    rent: false,
    auctionType: 1,
    contractType: 3
  });
};
export var getDefaulTypologyIdList = () => window._typologyIdListDefault;